<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">自定义报表</span>
		</div>
		<div class="h-panel-body">
			<!-- 工具条 -->
			<div class="toolbar">
				<button class="h-btn h-btn-primary" @click="createReport">
					<i class="h-icon-plus"></i><span>新建报表</span>
				</button>
				<button class="h-btn" @click="resetFilter">重置</button>
				<span class="filter-item">报表名称：<input type="text" v-model="filters.name" placeholder="请输入" @keyup.enter="loadList" /></span>
				<span class="filter-item">分组：<input type="text" v-model="filters.group" placeholder="请输入" @keyup.enter="loadList" /></span>
				<button class="h-btn" @click="loadList">查询</button>
			</div>

			<!-- 列表 -->
			<table class="bi-table">
				<thead>
					<tr>
						<th style="width:50px">#</th>
						<th>报表名称</th>
						<th>分组</th>
						<th style="width:90px">显示位置</th>
						<th>备注</th>
						<th style="width:150px">创建时间</th>
						<th style="width:150px">修改时间</th>
						<th style="width:120px">操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(row, idx) in pagedData" :key="row.id">
						<td>{{ (pagination.page - 1) * pagination.size + idx + 1 }}</td>
						<td>
							<span class="link" @click="openReport(row)">{{ row.reportName }}</span>
						</td>
						<td>{{ row.groupName || '-' }}</td>
						<td>{{ row.displayPosition }}</td>
						<td>{{ row.remark || '-' }}</td>
						<td>{{ fmt(row.createDate) }}</td>
						<td>{{ fmt(row.updateDate) }}</td>
						<td>
							<a @click="openReport(row)">编辑</a>
							<a class="danger" @click="remove(row)">删除</a>
						</td>
					</tr>
					<tr v-if="pagedData.length === 0">
						<td colspan="8" class="empty">暂无数据</td>
					</tr>
				</tbody>
			</table>

			<Pagination v-if="filteredData.length > pagination.size" align="right"
				:pagination="pagination" @change="changePage"></Pagination>
		</div>
	</app-content>
</template>

<script>
	export default {
		name: 'BiReportList',
		data() {
			return {
				loading: false,
				allData: [],
				filters: { name: '', group: '' },
				pagination: { page: 1, size: 10, total: 0 },
				pager: { size: 10 }
			};
		},
		computed: {
			filteredData() {
				const n = (this.filters.name || '').trim();
				const g = (this.filters.group || '').trim();
				return this.allData.filter(r =>
					(!n || (r.reportName || '').includes(n)) &&
					(!g || (r.groupName || '').includes(g))
				);
			},
			pagedData() {
				const start = (this.pagination.page - 1) * this.pagination.size;
				return this.filteredData.slice(start, start + this.pagination.size);
			}
		},
		methods: {
			loadList() {
				this.loading = true;
				this.$api.bi.list().then(({ data }) => {
					this.allData = data || [];
					this.pagination.total = this.allData.length;
					this.pagination.page = 1;
				}).finally(() => { this.loading = false; });
			},
			resetFilter() {
				this.filters = { name: '', group: '' };
				this.loadList();
			},
			createReport() {
				this.$router.push({ name: 'BiReportDesigner', params: { reportId: 0 } });
			},
			openReport(row) {
				this.$router.push({ name: 'BiReportDesigner', params: { reportId: row.id } });
			},
			remove(row) {
				this.$Confirm('确认删除该报表？').then(() => {
					this.$api.bi.delete(row.id).then(() => {
						this.$Message.success('已删除');
						this.loadList();
					});
				});
			},
			changePage(p) { this.pagination.page = p; },
			fmt(v) {
				if (!v) return '-';
				if (typeof v === 'string') return v.replace('T', ' ').slice(0, 19);
				return v;
			}
		},
		mounted() { this.loadList(); }
	};
</script>

<style scoped lang="less">
	.toolbar {
		margin-bottom: 14px;
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;
		.filter-item {
			display: inline-flex;
			align-items: center;
			input {
				width: 140px;
				margin-left: 4px;
			}
		}
	}
	.bi-table {
		width: 100%;
		border-collapse: collapse;
		th, td {
			border: 1px solid #e8e8e8;
			padding: 8px 10px;
			text-align: left;
			font-size: 13px;
		}
		th {
			background: #fafafa;
			font-weight: 600;
		}
		tr:hover td { background: #f5f9ff; }
		.link { color: @primary-color; cursor: pointer; }
		a { color: @primary-color; cursor: pointer; margin-right: 10px; }
		a.danger { color: #e74c3c; }
		.empty { text-align: center; color: #999; padding: 24px; }
	}
</style>
